import { createWebHistory, createRouter } from 'vue-router'
import Login from '../components/authentication/login-access.vue';
import DashboardIndex from '@/components/dashboard/dashboard-index.vue';
import ListCategory from '@/components/category/list-category.vue';
import authGuard from './authGuard';
import ListProduct from '@/components/product/list-product.vue';
import PdvPurchase from '@/components/pdv/pdv-purchase.vue';
import ListClient from '@/components/client/list-client.vue';
import ListQuote from '@/components/quote/list-quote.vue';
import ListEvent from '@/components/event/list-event.vue';
import ListFinancial from '@/components/financial/list-financial.vue';
import ListBranch from '@/components/branch/list-branch.vue';
import ListInventory from '@/components/inventory/list-inventory.vue';
import InventoryCount from '@/components/inventory/inventory-count.vue';
import ListSupplier from '@/components/supplier/list-supplier.vue';
import ListGateway from '@/components/gateway/list-gateway.vue';
import ListCost from '@/components/coast/list-cost.vue';
import SystemSettings from '@/components/setting/system-settings.vue';
import ConnectionWhatsapp from '@/components/whatsapp/connection-whatsapp.vue';
import TemplateEmail from '@/components/email/template-email.vue';
import ListService from '@/components/service/list-service.vue';
import DashboardFinancial from '@/components/financial/dashboard-financial.vue';
import NewPage from '@/components/lead/new-page.vue';
import ListPage from '@/components/lead/list-page.vue';
import LeadResponse from '@/components/lead/lead-response.vue';
import PageStatistics from '@/components/lead/page-statistics.vue';
import ListTicket from '@/components/crm/list-ticket.vue';
import ListRole from '@/components/user/list-role.vue';
import ListUser from '@/components/user/list-user.vue';
import ListLandingPage from '@/components/page/list-landing-page.vue';
import NewLandingPage from '@/components/page/new-landing-page.vue';


// 1. IMPORTAR O COMPONENTE DE CONTAGEM

const routes = [
  // Autenticação
  { path: '/login', name: 'Login', component: Login, meta: { guest: true } },

  // Rotas com autenticação necessária   
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardIndex,
    meta: { requiresAuth: true },
    // Se o host for o de clientes, intercepta e manda pro portal antes de carregar o dashboard
    beforeEnter: (to, from, next) => {
      if (window.location.hostname.startsWith('cliente.')) {
        next({ name: 'PortalClient' });
      } else {
        next();
      }
    }
  },

  /** Categorias */
  { path: '/category', name: 'Category', component: ListCategory, meta: { requiresAuth: true } },

  /** Centro de custo */
  { path: '/cost', name: 'Cost', component: ListCost, meta: { requiresAuth: true } },

  /** Filiais */
  { path: '/branch', name: 'Branch', component: ListBranch, meta: { requiresAuth: true } },

  /** Produtos */
  { path: '/product', name: 'Product', component: ListProduct, meta: { requiresAuth: true } },

  /** Serviços */
  { path: '/service', name: 'Service', component: ListService, meta: { requiresAuth: true } },

  /** Inventário */
  { path: '/inventory', name: 'Inventory', component: ListInventory, meta: { requiresAuth: true } },

  { path: '/inventory/:id/count', name: 'InventoryCount', component: InventoryCount, meta: { requiresAuth: true } },

  /** Clientes */
  { path: '/client', name: 'Client', component: ListClient, meta: { requiresAuth: true } },

  /** Fornecedores */
  { path: '/supplier', name: 'Supplier', component: ListSupplier, meta: { requiresAuth: true } },

  /** Orçamentos */
  { path: '/quote', name: 'Quote', component: ListQuote, meta: { requiresAuth: true } },

  /** Gateweays */
  { path: '/gateway', name: 'Gateway', component: ListGateway, meta: { requiresAuth: true } },

  /** PDV */
  { path: '/pdv', name: 'PDV', component: PdvPurchase, meta: { requiresAuth: true } },

  /** Financeiro */
  { path: '/financial', name: 'Financial', component: ListFinancial, meta: { requiresAuth: true } },

  /** Dashboard Financeiro */
  { path: '/financial-dashboard', name: 'DashboardFinancial', component: DashboardFinancial, meta: { requiresAuth: true } },

  /** Agenda */
  { path: '/event', name: 'event', component: ListEvent, meta: { requiresAuth: true } },

  /** Whatsapp */
  { path: '/whatsapp', name: 'Whatsapp', component: ConnectionWhatsapp, meta: { requiresAuth: true } },

  /** Template de e-mail */
  { path: '/template-email', name: 'template-email', component: TemplateEmail, meta: { requiresAuth: true } },

  /** Páginas de leads */
  { path: '/list-page-lead', name: 'list-page-lead', component: ListPage, meta: { requiresAuth: true } },
  { path: '/edit-page-lead/:id', name: 'EditPageLead', component: NewPage, meta: { requiresAuth: true } },
  { path: '/new-page-lead', name: 'new-page-lead', component: NewPage, meta: { requiresAuth: true } },
  { path: '/capture-pages/:id/responses', name: 'lead-response', component: LeadResponse, meta: { requiresAuth: true } },
  { path: '/capture-pages/:id/statistics', name: 'page-statistics', component: PageStatistics, meta: { requiresAuth: true } },

  /** Páginas de landing page */
  { path: '/list-landing-page', name: 'list-landing-page', component: ListLandingPage, meta: { requiresAuth: true } },
  { path: '/new-landing-page', name: 'new-landing-page', component: NewLandingPage, meta: { requiresAuth: true } },

  /**CRM */
  { path: '/crm', name: 'crm', component: ListTicket, meta: { requiresAuth: true } },

  /**Usuários */
  { path: '/role', name: 'role', component: ListRole, meta: { requiresAuth: true } },
  { path: '/user', name: 'user', component: ListUser, meta: { requiresAuth: true } },

  /** Configurações */
  { path: '/setting', name: 'Setting', component: SystemSettings, meta: { requiresAuth: true } },
  
  { path: '/:catchAll(.*)', redirect: '/' },

  //Jogo emotions
  {
    path: '/emoticon',
    name: 'InteractiveStory',
    component: () => import('@/views/public/interactive-story.vue'),
    meta: { requiresAuth: false }
  },

  //Traçar perfil
  {
    path: '/profile-client',
    name: 'DailypagLeadWizard',
    component: () => import('@/views/public/dailypag-lead-wizard.vue'),
    meta: { requiresAuth: false }
  },

   //Simulate whatsapp
  {
    path: '/simulate-whatsapp',
    name: 'SimulateWhatsapp',
    component: () => import('@/views/public/whatsapp-simulator.vue'),
    meta: { requiresAuth: false }
  },

  //E-commerce
  {
    path: '/shopping',
    name: 'ShoppingCart',
    component: () => import('@/views/public/shopping-cart.vue'),
    meta: { requiresAuth: false }
  },

  //Checkout
  {
    path: '/fatura/:id',
    name: 'PublicInvoice',
    component: () => import('@/views/public/public-invoice.vue'),
    meta: { requiresAuth: false }
  },

  //Portal Cliente
  //Checkout
  {
    path: '/portal-client',
    name: 'PortalClient',
    component: () => import('@/views/public/portal-client.vue'),
    meta: { requiresAuth: false }
  },

  //Página de lead
  {
    path: '/p/:slug',
    name: 'PublicCapturePage',
    component: () => import('@/views/public/PublicCapturePage.vue'),
    meta: { requiresAuth: false }
  },

  // Página do Landing Page Builder
  {
    path: '/lp/:slug',
    name: 'PublicLandingPage',
    component: () => import('@/views/public/PublicLandingPage.vue'),
    meta: { requiresAuth: false }
  }

];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(authGuard);

export default router;